import {
  getMessageNotifyVolume,
  getMessageNotifyPreset,
  type MessageNotifyPresetId,
} from './messageNotificationSoundSettings';

const notificationUrl = `${process.env.PUBLIC_URL ?? ''}/notificacao.mp3`;

function playBeep(volume: number): void {
  try {
    const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    const v = Math.min(1, Math.max(0, volume));
    gain.gain.setValueAtTime(0.0001, ctx.currentTime);
    gain.gain.linearRampToValueAtTime(v * 0.22, ctx.currentTime + 0.02);
    gain.gain.linearRampToValueAtTime(0.0001, ctx.currentTime + 0.14);
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.type = 'sine';
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.14);
    osc.onended = () => {
      void ctx.close();
    };
  } catch {
    // ignore
  }
}

function playRaw(preset: MessageNotifyPresetId, volume: number): void {
  if (volume <= 0) return;
  if (preset === 'beep') {
    playBeep(volume);
    return;
  }
  try {
    const audio = new Audio(notificationUrl);
    audio.volume = volume;
    void audio.play().catch(() => {});
  } catch {
    // ignore
  }
}

/** Som ao receber mensagem (direct ou grupo). Volume 0 = silenciado. */
export function playMessageNotificationSound(): void {
  playRaw(getMessageNotifyPreset(), getMessageNotifyVolume());
}

/** Pré-visualização no menu (mesmo preset e volume configurados). */
export function previewMessageNotificationSound(): void {
  playMessageNotificationSound();
}
